/**
 * NotificationBell - Sprint 19b
 *
 * Bell icon button with unread count badge.
 * Opens the notification drawer on click.
 * @see US-19b.06
 */

import { Bell } from 'lucide-react';
import { NotificationBadge } from './NotificationBadge';
import { useUnreadCount } from '../hooks/useNotifications';

interface NotificationBellProps {
  onClick: () => void;
  className?: string;
}

export function NotificationBell({ onClick, className = '' }: NotificationBellProps) {
  const { data: unreadData } = useUnreadCount();
  const unreadCount = unreadData?.count ?? 0;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        relative
        p-2 rounded-lg
        text-neutral-500 hover:text-primary-600
        hover:bg-neutral-100
        transition-colors
        focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
        ${className}
      `}
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} non lues)` : ''}`}
    >
      <Bell className="w-5 h-5" />
      <NotificationBadge count={unreadCount} />
    </button>
  );
}
